module.exports = __webpack_public_path__ + "static/media/minus.17f5c358.svg";